/**
 * @returns {relivConferenceDscMenuDirective}
 */
angular.module('relivConference').directive(
    'relivConferenceDscMenuDirective', [
        '$sce',
        'relivConferenceDscMenu',
        function (
            $sce,
            relivConferenceDscMenu
        ) {
            /**
             * Link function
             *
             * @param scope
             * @param element
             * @param attrs
             */
            function link(scope, element, attrs) {

                scope.relivConferenceDscMenu = relivConferenceDscMenu;

                scope.handleClose = function () {
                    relivConferenceDscMenu.setDisplay(scope.display);
                };

                scope.logOut = function () {
                    scope.handleClose();
                    window.location = '/login?logout=1';
                    //redirect
                };
            }

            return {
                link: link,
                scope: {},
                template: '' +
                '<style type="text/css">' +
                ' .conference-dsc-menu {' +
                '   width: 100%;' +
                ' }' +
                ' .conference-dsc-menu .nav.nav-pills{' +
                ' }' +
                ' .conference-dsc-menu .nav.nav-pills li{' +
                '   max-height: 2em;' +
                ' }' +
                ' .conference-dsc-menu .nav.nav-pills li a{' +
                '   color: #EEEEEE;' +
                '   padding: .3em 1em;' +
                ' }' +
                ' .conference-dsc-menu .nav.nav-pills li a:visited,' +
                ' .conference-dsc-menu .nav.nav-pills li a:active {' +
                '   color: #EEEEEE;' +
                ' }' +
                ' .conference-dsc-menu .nav.nav-pills li a:hover,' +
                ' .conference-dsc-menu .nav.nav-pills li a:focus {' +
                '   color: #00A4E4;' +
                ' }' +
                ' .conference-dsc-menu .real {' +
                '   position: fixed;' +
                '   background-color: #00A4E4;' +
                '   width: 100%;' +
                '   z-index: 1001;' +
                ' }' +
                ' .conference-dsc-menu .placeholder {' +
                '   visibility: hidden;' +
                ' }' +
                '</style>' +
                '<div class="conference-dsc-menu" ng-show="relivConferenceDscMenu.display">' +
                ' <div class="real">' +
                '  <ul class="nav nav-pills pull-right">' +
                '   <li><a href="/conference/check-in#/conference/ticket">Ticket List</a></li>' +
                '   <li><a href="/conference/check-in#/conference/ticket">Check-In</a></li>' +
                '   <li><a href="/conf">Buy Tickets</a></li>' +
                '   <li><a href="/conference/check-in#/conference/custom-badge-print">Print Custom Badge</a></li>' +
                '   <li><a href="/conference-report">Conference Report</a></li>' +
                '   <li><a ng-click="logOut()">Log Out</a></li>' +
                '   <li>' +
                '    <button type="button" class="btn btn-default btn-xs" aria-label="Close" ng-click="handleClose()">' +
                '     <span aria-hidden="true">×</span>' +
                '    </button>' +
                '   </li>' +
                '  </ul>' +
                ' </div>' +
                ' <div class="placeholder">' +
                '  <ul class="nav nav-pills">' +
                '   <li><a href="#">PLACEHOLDER</a></li>' +
                '  </ul>' +
                ' </div>' +
                '</div>',
            };
        },
    ]
);
